import { combineEpics } from 'redux-observable';
import horizontalOffset from './horizontal-offset/epic';
import offset from './offset/epic';
import size from './size/epic';
import toRow from './to-row/epic';
import verticalOffset from './vertical-offset/epic';

export default combineEpics(offset, verticalOffset, horizontalOffset, toRow, size);
